const getStyles = () => {
  return {
    section: {
      backgroundColor: '#000000',
      padding: '50px 20px',
      fontFamily: 'Raleway'
    },
    sectionH2: {
      textAlign: 'center',
      fontSize: '2em',
      marginBottom: '30px',
      textTransform: 'uppercase',
      fontFamily: 'Raleway',
      color: '#26BDBE'
    },
    sectionTagline: {
      textAlign: 'center',
      fontSize: '1.2em',
      marginBottom: '50px',
      fontStyle: 'italic',
      fontFamily: 'Raleway',
      color: '#999999',
      marginLeft: '60px',
      marginRight: '60px'
    },
    features: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
      gap: '20px',
      maxWidth: '1200px',
      margin: '0 auto',
      fontFamily: 'Raleway'
    },
    feature: {
      textAlign: 'center',
      backgroundColor: '#fff',
      padding: '20px',
      borderRadius: '10px',
      boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
      fontFamily: 'Raleway'
    },
    featureImg: {
      width: '80px',
      height: 'auto',
      marginBottom: '15px',
      fontFamily: 'Raleway'
    },
    featureH3: {
      fontSize: '1.5em',
      marginBottom: '10px',
      fontFamily: 'Raleway',
      color: '#4b4b4b'
    },
    featureP: {
      fontSize: '1em',
      color: '#666',
      fontFamily: 'Raleway'
    }
  };
};

export default getStyles;
